<div class="dialog-container mb-2">
  <div class="dialog-icon">
	  <i class="bi bi-exclamation-triangle-fill warning-icon"></i>

	   <span class="close-btn" (click)="close()">
    <img src="assets/images/close_button.svg" alt="Close Icon" />
	   </span>
  </div>

  <h2 class="dialog-title">
	{{ data.type === 'total' ? 'Question Limit Reached' : 'AI Question Limit Reached' }}
</h2>

  <p class="dialog-text">
	<ng-container *ngIf="data.type === aiQuizLimitExceededType.TOTAL; else aiLimit">
    You’ve reached your <strong>30-question</strong> limit under the Free Plan. Upgrade your plan
    to create more quizzes with unlimited questions.</ng-container>

	<ng-template #defaultAiLimit>
	You’ve used your <strong>10 free AI questions.</strong> 
	Add more manually or upgrade your plan for unlimited AI generation.
	</ng-template>

	 <ng-template #aiLimit>
    <ng-container *ngIf="data.message; else defaultAiLimit">
      {{ data.message }}
    </ng-container>
	</ng-template>
  </p>

  <div class="text-center">
    <button class="btn-add me-4" (click)="goToUpgradePage()">
      Upgrade Plan
    </button>
    <ng-container
	 *ngIf="data.type !== aiQuizLimitExceededType.TOTAL">
	<button class="btn-cancel" (click)="addManually()">Add Manually</button>
</ng-container>
  </div>
</div>
